export default "__VITE_ASSET__4yvBEvD6__"